<template>
    <div class="newsListPage">
        <div class="main">
            <div class="crumb">
                <router-link to="/pcpage/mainpage/home">
                    <span>{{ $t("message.home") }}</span>
                </router-link>
                <span class="icon">></span>
                <router-link to="/pcpage/detailpage/newslist" >
                    <span class="current">新闻中心</span>
                </router-link>
            </div>
            <div class="list">
                <div class="newsTitle" v-html="newsDetail.post_title">
                   
                </div>
                <div class="newsTimeCon">
                    <span v-show="newsDetail.published_time">{{newsDetail.published_time*1000|formatDate}}</span>
                </div>
                <div v-html="newsDetail.post_content" class="newsContent">
                </div>
            </div>
        </div>
        <!-- <div class="bottom">
            <span>
                版权所有 © 2019 孔子学院总部     京ICP 备 08002516号-5
            </span>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'newslist',
    data: function() {
        return {
        newsDetail: [],
        isShow: true
        }
    },
    methods: {
    // 判断是否为整数
    isInteger(obj) {
        return obj%1 === 0
    },
    showAll () {
        this.isShow = true
    },
    getNewsDetail(id,lang='cn') {
      this.$utils
        .get("portal/api/getNews", {
            lang: lang,
            id: id
        })
        .then(res => {
            this.newsDetail = res.data.data.article
        });
    }
  },
  mounted() {
    let newsId = this.$route.query.id
    this.getNewsDetail(newsId)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsListPage {
    width: 100%;
    min-height: 100%;
    margin: auto;
    background-color: #ebf4fd;
    .main {
        width: 62.5%;
        margin: auto;
        padding: 30px 50px 0;
        min-height: 100%;
        box-sizing: border-box;
        background-color: #fff;
        .crumb {
            font-size: 14px;
            a {
                color: #282828;
                text-decoration: none;
            }
            .icon {
                display: inline-block;
                margin: 0 6px;
            }
            .current {
                color: #1c58c1;
            }
        }
        .title {
            margin: 18px 0 18px;
            height: 50px;
            background-color: #e1eef3;
            color: #1c58c1;
            font-size: 28px;
            line-height: 50px;
            font-weight: bold;
            text-indent: 15px;
        }
        .list {
            height: calc(100% - 25px);
            padding-bottom: 50px;
            border: 1px solid #e5e5e5;
            border-bottom: none;
            margin-top: 10px;
            .newsTitle {
                font-size: 36px;
                line-height: 1.2;
                font-weight: bold;
                color: #282828;
                text-align: center;
                margin: 57px 0 40px;
                padding: 0 145px;
            }
            .newsTimeCon {
                width: calc(100% - 108px);
                margin: 0 auto 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #e5e5e5;
                span {
                    font-size: 16px;
                    color: #999;
                }
            }
            .newsContent {
                padding: 0 54px;
                line-height: 2;
                /deep/ p {
                    font-size: 18px;
                    color: #282828;
                    line-height: 2;
                    margin: 5px auto;
                    text-indent: 2em;
                    strong {
                        font-weight: bold;
                        margin-left: -2em;
                    }
                    img {
                        width: 550px;
                        margin-left: -2em;
                    }
                }

                /deep/ video {
                    display: block;
                    width: 785px;
                    height: 523px;
                    margin: 0 auto;
                }
            }

        }
    }
    .bottom {
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        
        background-image: url(../img/bg.png);
        span {
            opacity: 0.5;
        }
    } 
}
</style>
